import { Route } from '@angular/router';
import { FULL_ACCESS_ROLES } from '@app/core/services/http/auth/auth.service';

export const partnerRoutes: Route = {
  path: 'partner',
  data: { roles: [...FULL_ACCESS_ROLES] },
  loadComponent: () => import('./partner-shell.component').then(m => m.PartnerShellComponent),
  children: [
    { path: '', pathMatch: 'full', redirectTo: 'list' },
    {
      path: 'list',
      loadComponent: () => import('./partners/partners.component').then(m => m.PartnersComponent),
    },
    {
      path: 'details/:partnerId',
      loadComponent: () =>
        import('./partners/partner-details/partner-details.component').then(
          m => m.PartnerDetailsComponent
        ),
    },
    {
      path: 'networks',
      loadComponent: () =>
        import('./partner-networks/partner-networks.component').then(
          m => m.PartnerNetworksComponent
        ),
    },
    {
      path: 'network-details/:networkId',
      loadComponent: () =>
        import('./partner-networks/network-details/network-details.component').then(
          m => m.NetworkDetailsComponent
        ),
    },
    {
      path: 'stores',
      loadComponent: () =>
        import('./partner-stores/partner-stores.component').then(m => m.PartnerStoresComponent),
    },
    {
      path: 'roles',
      loadComponent: () => import('./roles/roles.component').then(m => m.RolesComponent),
    },
    {
      path: 'b2b-admins',
      data: { roles: ['ROLE_SUPER_ADMIN'] },
      loadComponent: () =>
        import('./b2b-admins/b2b-admins.component').then(m => m.B2bAdminsComponent),
    },
    {
      path: 'network-rules',
      loadComponent: () =>
        import('./network-rules/network-rules.component').then(m => m.NetworkRulesComponent),
    },
    {
      path: 'network-rule-details/:ruleId',
      loadComponent: () =>
        import('./network-rules/rule-details/rule-details.component').then(
          m => m.RuleDetailsComponent
        ),
    },
    {
      path: 'role-details/:employeeId',
      loadComponent: () =>
        import('./roles/role-details/role-details.component').then(m => m.RoleDetailsComponent),
    },
    {
      path: 'store-details/:storeId',
      loadComponent: () =>
        import('./partner-stores/store-details/store-details.component').then(
          m => m.StoreDetailsComponent
        ),
    },
  ],
};
